import * as React from 'react'

import { useScene } from '../context/SceneContext'
import { useConfig } from '../context/ConfigContext'

const LANE_HEIGHT = 6
const LABEL_HEIGHT = 16
const GAP = 6
const DOT_CENTER = 9


const CHAR_WIDTH = 6
const CHROME_WIDTH = 24
const TEXT_GAP = 6
const EDGE_PADDING = 4
const LEFT_INSET = 4
const MAX_OVERHANG = 28

export type RestInfoLabelProps = {
  color: string
  duration: string
  left: number
  width: number
  lane: number
}

export const RestInfoLabel: React.FC<RestInfoLabelProps> = ({
  color,
  duration,
  left,
  width,
  lane,
}) => {
  const scene = useScene()
  const { showRestLabels, printMode } = useConfig()

  if (!showRestLabels || printMode || scene.weekly || scene.days !== 1) {
    return null
  }
  if (!duration || width <= 0) {
    return null
  }

  const labelWidth = CHROME_WIDTH + duration.length * CHAR_WIDTH

  if (labelWidth > width + MAX_OVERHANG - LEFT_INSET) {
    return null
  }

  const bottom = LANE_HEIGHT + GAP + lane * (LABEL_HEIGHT + GAP)
  const topAboveBaseline = lane * LANE_HEIGHT + bottom + LABEL_HEIGHT

  if (topAboveBaseline > scene.height - scene.bottomPadding) {
    return null
  }

  const maxLeft = Math.max(EDGE_PADDING, scene.width - labelWidth - EDGE_PADDING)
  const clampedLeft = Math.min(Math.max(left + LEFT_INSET, EDGE_PADDING), maxLeft)
  const offset = clampedLeft - left

  const connectorLeft = Math.min(Math.max(offset + DOT_CENTER, 0), Math.max(width - 1, 0))

  return (
    <>
      <div
        style={{
          position: 'absolute',
          left: connectorLeft,
          bottom: LANE_HEIGHT,
          width: 1,
          height: bottom - LANE_HEIGHT,
          background: 'rgba(31, 41, 55, 0.45)',
          pointerEvents: 'none',
        }}
      />
      <div
        className="tw-flex tw-items-center tw-rounded tw-bg-[#1F2937]/90 tw-text-white tw-shadow-sm"
        style={{
          position: 'absolute',
          left: offset,
          bottom,
          height: LABEL_HEIGHT,
          gap: TEXT_GAP,
          padding: '0 6px',
          fontSize: 11,
          lineHeight: '11px',
          whiteSpace: 'nowrap',
          pointerEvents: 'none',
        }}
      >
        <span
          style={{
            width: 6,
            height: 6,
            flex: '0 0 auto',
            borderRadius: '50%',
            background: color,
          }}
        />
        <span style={{ fontWeight: 600 }}>{duration}</span>
      </div>
    </>
  )
}

RestInfoLabel.displayName = 'RestInfoLabel'
